import { render, staticRenderFns } from "./es.vue?vue&type=template&id=0880f484&scoped=true&lang=html&"
import script from "./es.vue?vue&type=script&lang=js&"
export * from "./es.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0880f484",
  null
  
)

export default component.exports